//#TODO general type?

export enum AscCertificationStatus {
  None = "none",
  AscCertified = "ascCertified",
  AscAssessment = "ascAssessment",
  NonAsc = "nonAsc",
}
